import { Component, Inject, OnInit } from '@angular/core';

import { PrazoService } from '@app/services/prazo.service';
import { PrazoGerenciamentoPesquisa, PrazoGerenciamentoLista } from '@app/pages/processos/gerenciar-prazos/gerenciar-prazos.model';
import { ProcessoMovimentacao, TipoMovimentacao } from '@app/models/processo-movimentacao';
import { CDSMask } from '@app/utils/cds-mask';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-gerenciar-mov-administrativa.component',
  templateUrl: './gerenciar-mov-administrativa.component.html',
  styleUrls: ['./gerenciar-mov-administrativa.component.scss']
})
export class GerenciarMovAdministrativaComponent implements OnInit {

  pesquisaFiltro: PrazoGerenciamentoPesquisa;

  lstPrazoGerenciamento: PrazoGerenciamentoLista[];
  lstUsuario: IdDescricao[];
  lstUnidade: IdDescricao[];
  lstMeAviseTipo: IdDescricao[];

  lstProcessoMovimentacao: ProcessoMovimentacao[];

  cdsMask: CDSMask = new CDSMask();

  constructor(
    private prazoService: PrazoService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    this.pesquisaFiltro = new PrazoGerenciamentoPesquisa();
    this.pesquisaFiltro.TipoMovimentacao = TipoMovimentacao.ADMINISTRATIVA;
    this.pesquisaFiltro.FiltrarDataPor = 'Data';
    this.pesquisaFiltro.FuncionarioId = 0;
    this.pesquisaFiltro.Realizado = 2;
    this.pesquisaFiltro.Protocolado = 0;
    this.pesquisaFiltro.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
    this.pesquisaFiltro.DataFinal = UtilitarioService.retornaDataAtualMaisDias(7);
    this.pesquisaFiltro.MeAviseTipoId = -1;
    this.pesquisaFiltro.MeAviseTipoId = null;
    this.pesquisaFiltro.UnidadeId = null;
  }

  ngOnInit() {
    this.consultasService.consultar('USUARIO').toPromise().then(data => {
      const todos = new IdDescricao();
      todos.Id = 0;
      todos.Descricao = 'Todos os funcionários';
      this.lstUsuario = [todos, ...data];
    });
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidade = data);
    this.consultasService.consultar('MEAVISETIPO').toPromise().then(data => this.lstMeAviseTipo = data);
    this.pesquisar();
  }

  public pesquisar() {
    //this.prazoService.obterPrazoGerenciamentoAdm(this.pesquisaFiltro).toPromise().then(data => this.lstPrazoGerenciamento = data);
    this.prazoService.obterPrazoGerenciamentoAdm(this.pesquisaFiltro).toPromise().then(
      data => {
        this.lstPrazoGerenciamento = data},
      erro => {
        this.toastr.warning("Realize a pesquisa novamente.");
      });
  }

  retornaCaminho(idProcesso: number, tipoMovimentacaoId: number): string {
    return '/processos/processo/' + idProcesso + UtilitarioService.retornaTipoMovimentacao(tipoMovimentacaoId);
  }

  public obterCorStatus(status: string): string {
    switch (status) {
      case 'Atrasado':
        return 'red';
      case 'No prazo':
        return 'green';
      case 'Próximo do prazo':
        return 'yellow';
      case 'Realizado':
        return 'darkgreen';
    }
  }
}
